import { Image, message, Modal } from "antd";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks.ts";
import { previewFileByURL } from "../../../redux/actions/requirementsActions.tsx";
import { Loading } from "../../common/Loading.tsx";
import { File } from "../../../redux/interfaces/folder.types.ts";
import { useIsMobile } from "../../../hooks/useIsMobile.ts";
import { extractErrorMessage } from "../../../utils/extractErrorMessage.ts";

interface Props {
  file: File;
  opened: boolean;
  handleOpen: (opened: boolean) => void;
}

export const FilePreview: React.FC<Props> = ({ file, opened, handleOpen }) => {
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [filePreview, setFilePreview] = useState<string>("");
  const { loading } = useAppSelector((state) => state.requirements);
  const { isMobile } = useIsMobile();

  const modalWidth = isMobile ? "90vw" : "75vw";

  const onModalClose = () => {
    handleOpen(false);
  };

  const onSetUrlPreview = async () => {
    try {
      const url = await dispatch(previewFileByURL(file)).unwrap();
      setFilePreview(url);
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo cargar la vista previa."));
    }
  };

  useEffect(() => {
    if (opened) onSetUrlPreview();

    return () => {
      URL.revokeObjectURL(filePreview);
    };
  }, [opened]);

  return (
    <Modal
      title={file.filename}
      open={opened}
      onCancel={onModalClose}
      className="p-0 justify-items-center"
      centered
      footer={null}
    >
      {contextHolder}
      {loading ? (
        <div
          style={{ height: "75vh" }}
          className="flex justify-center items-center"
        >
          <Loading />
        </div>
      ) : file.filename.endsWith(".pdf") ? (
        <iframe
          id="preview-pdf"
          title={file.filename}
          className="w-full"
          style={{ height: "75vh", width: modalWidth, border: "none" }}
          src={filePreview}
        />
      ) : (
        <Image
          src={filePreview}
          id="preview-image"
          alt={file.filename}
          sizes={modalWidth}
          style={{ width: "100%", maxHeight: "75vh" }}
        />
      )}
    </Modal>
  );
};
